export const ADD_BONUS = 'ADD_BONUS';
export const ADD_ENTITY = 'ADD_ENTITY';
export const ADD_NEW_FRIEND_GROUP = 'ADD_NEW_FRIEND_GROUP';
export const API_CALL = 'API_CALL';
export const API_CALL_FAILURE = 'API_CALL_FAILURE';
export const API_CALL_REQUEST = 'API_CALL_REQUEST';
export const API_CALL_SUCCESS = 'API_CALL_SUCCESS';
export const BEGIN_SEARCH = 'BEGIN_SEARCH';
export const BEGIN_SEARCH_FRIEND = 'BEGIN_SEARCH_FRIEND';
export const CANCEL_EDIT_FRIEND_GROUP = 'CANCEL_EDIT_FRIEND_GROUP';
export const CANCEL_NEW_FRIEND_GROUP = 'CANCEL_NEW_FRIEND_GROUP';
export const CLEAR_CHALLENGE = 'CLEAR_CHALLENGE';
export const CLEAR_CHALLENGE_LIST = 'CLEAR_CHALLENGE_LIST';
export const SMART_LINEUP_FAILED = 'SMART_LINEUP_FAILED';
export const CLEAR_CHALLENGE_POLL = 'CLEAR_CHALLENGE_POLL';
export const CLEAR_FRIEND_SEARCH_RESULTS = 'CLEAR_FRIEND_SEARCH_RESULTS';
export const CLEAR_LIST_POLL = 'CLEAR_LIST_POLL';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const CLEAR_SEARCH_FRIEND = 'CLEAR_SEARCH_FRIEND';
export const COPY_LINK_SUCCESS = 'COPY_LINK_SUCCESS';
export const USER_PLAYUP_CAMPAIGN_STATUS = 'USER_PLAYUP_CAMPAIGN_STATUS';
export const COPYING_LINK = 'COPYING_LINK';
export const DECREMENT_PENDING_ENTRY = 'DECREMENT_PENDING_ENTRY';
export const DELETING_GROUP_CANCEL = 'DELETING_GROUP_CANCEL';
export const DELETING_GROUP_CONFIRM = 'DELETING_GROUP_CONFIRM';
export const DEPOSIT_SUCCESS = 'DEPOSIT_SUCCESS';
export const DESELECT_GROUP_FRIEND = 'DESELECT_GROUP_FRIEND';
export const DISABLE_MY_LIVE_CHALLENGES = 'DISABLE_MY_LIVE_CHALLENGES';
export const DISABLE_TRAINER_CHALLENGES = 'DISABLE_TRAINER_CHALLENGES';
export const EDIT_FRIEND_GROUP = 'EDIT_FRIEND_GROUP';
export const ENABLE_MY_LIVE_CHALLENGES = 'ENABLE_MY_LIVE_CHALLENGES';
export const ENABLE_TRAINER_CHALLENGES = 'ENABLE_TRAINER_CHALLENGES';
export const END_SEARCH = 'END_SEARCH';
export const END_SEARCH_FRIEND = 'END_SEARCH_FRIEND';
export const ENTER_EDIT_MODE = 'ENTER_EDIT_MODE';
export const EXCLUDE_ENTITY = 'EXCLUDE_ENTITY';
export const EXIT_EDIT_MODE = 'EXIT_EDIT_MODE';
export const FANTASY_INSIDER_RESET = 'FANTASY_INSIDER_RESET';
export const FANTASY_INSIDER_RESET_EXPOSURE_SETTINGS = 'FANTASY_INSIDER_RESET_EXPOSURE_SETTINGS';
export const FANTASY_INSIDER_UPDATE_SETTINGS = 'FANTASY_INSIDER_UPDATE_SETTINGS';
export const FETCH_OPPONENT_ENTRY = 'api/OPPONENT_ENTRY';
export const FILTER_ENTRY_STATUS = 'FILTER_ENTRY_STATUS';
export const FORM_FIELDS_RESET = 'FORM_FIELDS_RESET';
export const GET_ACCESS_TOKEN_STARTED = 'GET_ACCESS_TOKEN_STARTED';
export const GET_ACCESS_TOKEN_FINISHED = 'GET_ACCESS_TOKEN_FINISHED';
export const INCREMENT_PENDING_ENTRY = 'INCREMENT_PENDING_ENTRY';
export const INITIALISE_USER = 'INITIALISE_USER';
export const LOCK_ALL = 'LOCK_ALL';
export const LOCK_ENTITY = 'LOCK_ENTITY';
export const PAYPAL_DEPOSIT_FAILURE = 'PAYPAL_DEPOSIT_FAILURE';
export const PAYPAL_DEPOSIT_REQUEST = 'PAYPAL_DEPOSIT_REQUEST';
export const PAYPAL_DEPOSIT_SUCCESS = 'PAYPAL_DEPOSIT_SUCCESS';
export const PLAYER_GAME_RESET = 'PLAYER_GAME_RESET';
export const PLAYER_SWAP_SET_GROUP = 'PLAYER_SWAP_SET_GROUP';
export const PLAYER_SWAP_SET_SELECTED = 'PLAYER_SWAP_SET_SELECTED';
export const PLAYER_SWAP_SET_SWAP = 'PLAYER_SWAP_SET_SWAP';
export const REMOVE_BONUS = 'REMOVE_BONUS';
export const REMOVE_ENTITY = 'REMOVE_ENTITY';
export const REMOVE_FRIEND = 'REMOVE_FRIEND';
export const REMOVE_FRIEND_FAILURE = 'REMOVE_FRIEND_FAILURE';
export const REMOVE_FRIEND_REQUEST = 'REMOVE_FRIEND_REQUEST';
export const REMOVE_FRIEND_REQUEST_FAILURE = 'REMOVE_FRIEND_REQUEST_FAILURE';
export const REMOVE_FRIEND_REQUEST_SUCCESS = 'REMOVE_FRIEND_REQUEST_SUCCESS';
export const REMOVE_FRIEND_SUCCESS = 'REMOVE_FRIEND_SUCCESS';
export const RESET_PLAYUP_CAMPAIGN = 'RESET_PLAYUP_CAMPAIGN';
export const RESET_CHALLENGE = 'RESET_CHALLENGE';
export const RESET_CHALLENGE_LIST = 'RESET_CHALLENGE_LIST';
export const RESET_CHALLENGE_LIST_FILTER = 'RESET_CHALLENGE_LIST_FILTER';
export const RESET_CHALLENGE_LIST_GROUP_BY = 'RESET_CHALLENGE_LIST_GROUP_BY';
export const RESET_CHALLENGE_LIST_SORT = 'RESET_CHALLENGE_LIST_SORT';
export const RESET_CHALLENGE_LIST_SPORT = 'RESET_CHALLENGE_LIST_SPORT';
export const RESET_COMPATIBLE_CHALLENGES = 'RESET_COMPATIBLE_CHALLENGES';
export const RESET_DEPOSIT_DETAILS = 'RESET_DEPOSIT_DETAILS';
export const RESET_FANTASY_INSIDER_PROJECTIONS = 'RESET_FANTASY_INSIDER_PROJECTIONS';
export const RESET_FRIEND_REQUESTS = 'RESET_FRIEND_REQUESTS';
export const RESET_FRIENDS = 'RESET_FRIENDS';
export const RESET_GIFTSTORE = 'RESET_GIFTSTORE';
export const RESET_GIFTSTORE_ERRORS = 'RESET_GIFTSTORE_ERRORS';
export const RESET_GROUP = 'RESET_GROUP';
export const RESET_JACKPOT_SLOTS = 'RESET_JACKPOT_SLOTS';
export const RESET_LINEUP = 'RESET_LINEUP';
export const RESET_LINEUP_ERRORS = 'RESET_LINEUP_ERRORS';
export const RESET_LOBBY_FILTER = 'RESET_LOBBY_FILTER';
export const RESET_LOBBY_GROUP_BY = 'RESET_LOBBY_GROUP_BY';
export const RESET_MY_TEAMS = 'RESET_MY_TEAMS';
export const RESET_OPPONENT_ENTRY = 'RESET_OPPONENT_ENTRY';
export const RESET_PERFORMANCE_DIFF = 'RESET_PERFORMANCE_DIFF';
export const RESET_PLAYERLIST_FILTERS = 'RESET_PLAYERLIST_FILTERS';
export const RESET_SEARCH_FRIEND = 'RESET_SEARCH_FRIEND';
export const RESET_SELECTED_CHALLENGE = 'RESET_SELECTED_CHALLENGE';
export const RESET_SPORT_CATEGORIES = 'RESET_SPORT_CATEGORIES';
export const RESET_TRAINER_CHALLENGE_LIST = 'RESET_TRAINER_CHALLENGE_LIST';
export const RESET_USER_ERRORS = 'RESET_USER_ERRORS';
export const RESET_WITHDRAW_DETAILS = 'RESET_WITHDRAW_DETAILS';
export const SAVE_URL_QUERY = 'SAVE_URL_QUERY';
export const SAVING_GROUP_CANCEL = 'SAVING_GROUP_CANCEL';
export const SAVING_GROUP_CONFIRM = 'SAVING_GROUP_CONFIRM';
export const SEARCH_FRIEND = 'SEARCH_FRIEND';
export const SEARCH_FRIEND_SUCCESS = 'SEARCH_FRIEND_SUCCESS';
export const SEARCH_PLAYERS_LIST = 'SEARCH_PLAYERS_LIST';
export const SEARCH_USER = 'SEARCH_USER';
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS';
export const SELECT_BONUS = 'SELECT_BONUS';
export const SELECT_FRIEND = 'SELECT_FRIEND';
export const SELECT_GROUP_FRIEND = 'SELECT_GROUP_FRIEND';
export const SET_CHALLENGE_LIST_CATEGORY = 'SET_CHALLENGE_LIST_CATEGORY';
export const SET_CHALLENGE_LIST_FILTER = 'SET_CHALLENGE_LIST_FILTER';
export const SET_CHALLENGE_LIST_FLAGS = 'SET_CHALLENGE_LIST_FLAGS';
export const SET_CHALLENGE_LIST_GROUP_BY = 'SET_CHALLENGE_LIST_GROUP_BY';
export const SET_CHALLENGE_LIST_SORT = 'SET_CHALLENGE_LIST_SORT';
export const SET_CHALLENGE_LIST_SPORT = 'SET_CHALLENGE_LIST_SPORT';
export const SET_CHAT_CHANNEL = 'SET_CHAT_CHANNEL';
export const SET_COMPETITOR_COMPARISON = 'SET_COMPETITOR_COMPARISON';
export const SET_CURRENT_GROUP = 'SET_CURRENT_GROUP';
export const SET_DEPOSIT_LIMITS_AFTERWARDS = 'SET_DEPOSIT_LIMITS_AFTERWARDS';
export const SET_FORM_FIELD = 'SET_FORM_FIELD';
export const SET_FORM_FIELDS_IN_BULK = 'SET_FORM_FIELDS_IN_BULK';
export const SET_GAME_FILTER = 'SET_GAME_FILTER';
export const SET_GROUP = 'SET_GROUP';
export const SET_GROUP_NAME = 'SET_GROUP_NAME';
export const FANTASY_INSIDER_SET_PLAYERS = 'FANTASY_INSIDER_SET_PLAYERS';
export const SET_LINE_UP = 'SET_LINE_UP';
export const SET_LINEUP_TYPE_FILTER = 'SET_LINEUP_TYPE_FILTER';
export const SET_LOBBY_CATEGORY = 'SET_LOBBY_CATEGORY';
export const SET_LOBBY_FILTER = 'SET_LOBBY_FILTER';
export const SET_LOBBY_GROUP_BY = 'SET_LOBBY_GROUP_BY';
export const SET_LOBBY_SPORT = 'SET_LOBBY_SPORT';
export const SET_LOBBY_SUB_CATEGORY = 'SET_LOBBY_SUB_CATEGORY';
export const SET_NOTIFICATIONS_READ = 'SET_NOTIFICATIONS_READ';
export const SET_OPPONENT_ENTRY = 'SET_OPPONENT_ENTRY';
export const SET_PERFORMANCE_DIFF = 'SET_PERFORMANCE_DIFF';
export const SET_PLAYER_TYPE_FILTER = 'SET_PLAYER_TYPE_FILTER';
export const SET_PLAYERLIST_SORT = 'SET_PLAYERLIST_SORT';
export const SET_POLL_DURATION = 'SET_POLL_DURATION';
export const SET_POSITION_FILTER = 'SET_POSITION_FILTER';
export const UPDATE_PLAYERS = 'UPDATE_PLAYERS';
export const SET_SELECTED_CHALLENGE = 'SET_SELECTED_CHALLENGE';
export const SET_SELECTED_LINEUP_IDS = 'SET_SELECTED_LINEUP_IDS';
export const SET_USER_QUESTION_ANSWER = 'SET_USER_QUESTION_ANSWER';
export const SHARE_CHALLENGE_FAILURE = 'SHARE_CHALLENGE_FAILURE';
export const SHARE_CHALLENGE_REQUEST = 'SHARE_CHALLENGE_REQUEST';
export const SHARE_CHALLENGE_SUCCESS = 'SHARE_CHALLENGE_SUCCESS';
export const START_API_POLL = 'START_API_POLL';
export const STOP_API_POLL = 'STOP_API_POLL';
export const STOP_JACKPOT_SLOTS_SPINNING = 'STOP_JACKPOT_SLOTS_SPINNING';
export const SUBMIT_CHALLENGE_FAILURE = 'SUBMIT_CHALLENGE_FAILURE';
export const SUBMIT_CHALLENGE_REQUEST = 'SUBMIT_CHALLENGE_REQUEST';
export const SUBMIT_CHALLENGE_SUCCESS = 'SUBMIT_CHALLENGE_SUCCESS';
export const SUBMIT_MULTIPLE_FAILURE = 'SUBMIT_MULTIPLE_FAILURE';
export const SUBMIT_MULTIPLE_REQUEST = 'SUBMIT_MULTIPLE_REQUEST';
export const SUBMIT_MULTIPLE_SUCCESS = 'SUBMIT_MULTIPLE_SUCCESS';
export const SUBMIT_MULTIPLE_LINEUP_ENTRY_REQUEST = 'SUBMIT_MULTIPLE_LINEUP_ENTRY_REQUEST';
export const SUBMIT_MULTIPLE_LINEUP_ENTRY_SUCCESS = 'SUBMIT_MULTIPLE_LINEUP_ENTRY_SUCCESS';
export const SUBMIT_MULTIPLE_LINEUP_ENTRY_FAILURE = 'SUBMIT_MULTIPLE_LINEUP_ENTRY_FAILURE';
export const SWITCH_SELECTED_POSITION = 'SWITCH_SELECTED_POSITION';
export const SWITCH_LINEUP_TYPE_FILTER = 'SWITCH_LINEUP_TYPE_FILTER';
export const TOGGLE_AUTO_ADVANCE_POSITIONS_FILTER = 'TOGGLE_AUTO_ADVANCE_POSITIONS_FILTER';
export const TOGGLE_PROJECTED_SCORE_FILTER = 'TOGGLE_PROJECTED_SCORE_FILTER';
export const TOGGLE_CHALLENGE_LIST_FILTER = 'TOGGLE_CHALLENGE_LIST_FILTER';
export const TOGGLE_CHAT = 'TOGGLE_CHAT';
export const TOGGLE_DARK_MODE = 'TOGGLE_DARK_MODE';
export const TOGGLE_ENTITY_PROPERTY = 'TOGGLE_ENTITY_PROPERTY';
export const TOGGLE_LABEL_EXCLUDE = 'TOGGLE_LABEL_EXCLUDE';
export const TOGGLE_LABEL_INCLUDE = 'TOGGLELABEL_INCLUDE';
export const TOGGLE_LOBBY_FILTER = 'TOGGLE_LOBBY_FILTER';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
export const TOGGLE_PLAYERLIST_GAMES_FILTER = 'TOGGLE_PLAYERLIST_GAMES_FILTER';
export const TOGGLE_PLAYERLIST_GAMES_STATUS_FILTER = 'TOGGLE_PLAYERLIST_GAMES_STATUS_FILTER';
export const TOGGLE_PLAYERLIST_TEAMS_FILTER = 'TOGGLE_PLAYERLIST_TEAMS_FILTER';
export const TOGGLE_PLAYERLIST_SELECTED_TEAMS_FILTER = 'TOGGLE_PLAYERLIST_SELECTED_TEAMS_FILTER';
export const TOGGLE_POSITION_FILTER = 'TOGGLE_POSITION_FILTER';
export const TOGGLE_SHOW_CUSTOM = 'TOGGLE_SHOW_CUSTOM';
export const TOGGLE_SHOW_H2H = 'TOGGLE_SHOW_H2H';
export const TOGGLE_SPORT_FILTER = 'TOGGLE_SPORT_FILTER';
export const UNLOCK_ALL = 'UNLOCK_ALL';
export const UNLOCK_ENTITY = 'UNLOCK_ENTITY';
export const UNSET_LOBBY_FILTER = 'UNSET_LOBBY_FILTER';
export const USER_TOGGLE_CAMPAIGN_MODAL = 'USER_TOGGLE_CAMPAIGN_MODAL';
export const UPDATE_CHALLENGE_FAILURE = 'UPDATE_CHALLENGE_FAILURE';
export const UPDATE_CHALLENGE_REQUEST = 'UPDATE_CHALLENGE_REQUEST';
export const UPDATE_CHALLENGE_SUCCESS = 'UPDATE_CHALLENGE_SUCCESS';
export const UPDATE_ENTITY_PROPERTY = 'UPDATE_ENTITY_PROPERTY';
export const VIEW_FRIEND = 'VIEW_FRIEND';
export const SET_IS_WEBVIEW = 'SET_IS_WEBVIEW';
